import { FaFacebookF, FaInstagram, FaTiktok, FaTripadvisor } from "react-icons/fa";
import { IoIosArrowRoundForward } from "react-icons/io";
import { useTranslation } from "react-i18next";

import Pyme from "../../assets/PYME.webp";
import TripAdvisorIMG from "../../assets/tripadvisor-5-star1.png";
import ICTLogo from "../../assets/ict-logo.png";
import ESSENTIALLogo from "../../assets/Esencial-CR.png";
import Modal from "../modal/Modal";
import { useState } from "react";

const Footer = () => {
  const { i18n } = useTranslation();
  const [openModal, setOpenModal] = useState<boolean>(false);

  return (
    <footer className="text-white">
      <Modal
        open={openModal}
        onClose={setOpenModal}
        message={i18n.t("footer.notAvailableNewsLetter.message")}
        title={i18n.t("footer.notAvailableCard.title")}
      />

      {/* Top Section */}
      <section className="bg-[#2a4328] py-8 px-6">
        <div className="max-w-7xl mx-auto grid md:grid-cols-7 gap-7">


          {/* Company Info */}
          <article className="col-span-2 md:pt-4">
            <h2 className="text-xl font-bold">{i18n.t("footer.company.title")}</h2>
            <p className="mt-2 text-sm italic">{i18n.t("footer.company.description")}</p>
          </article>

          {/* Explore */}
          <nav aria-label="explore" className="col-span-1 md:pt-4">
            <h3 className="font-semibold text-lg">{i18n.t("footer.explore.title")}</h3>
            <ul className="mt-2 space-y-2 text-sm text-left italic pl-0">
              <li><a href="/multi-day-tours" className="text-white">{i18n.t("footer.explore.tours")}</a></li>
              <li><a href="/blogs" className="text-white">{i18n.t("footer.explore.blog")}</a></li>
              <li><a href="/about-us" className="text-white">{i18n.t("footer.explore.about")}</a></li>
              <li><a href="/contact" className="text-white">{i18n.t("footer.explore.contact")}</a></li>
              <li><a href="/faqs" className="text-white">{i18n.t("footer.explore.faqs")}</a></li>
            </ul>
          </nav>

          {/* Support */}
          <nav aria-label="support" className="col-span-2 md:pt-4">
            <h3 className="font-semibold text-lg">{i18n.t("footer.support.title")}</h3>
            <ul className="mt-2 space-y-2 text-sm text-left italic pl-0">
              <li><a href="/terms&conditions/" className="text-white">{i18n.t("footer.support.terms")}</a></li>
              <li><a href={`/privacy-policy`} className="text-white">{i18n.t("footer.support.privacy")}</a></li>
              <li><a href="/cancellation-policy/" className="text-white">{i18n.t("footer.support.cancel")}</a></li>
              <li><a href="/payment/" className="text-white">{i18n.t("footer.support.payment")}</a></li>
              <li><a href="/sustainability/" className="text-white">{i18n.t("footer.support.sustainability")}</a></li>
            </ul>
          </nav>

          {/* Contact */}
          <section aria-label={i18n.t("footer.contact.title")} className="col-span-2 md:pt-4">
            <h3 className="font-semibold text-lg">{i18n.t("footer.contact.title")}</h3>
            <p className="mt-2 italic text-sm">
              {i18n.t("footer.contact.location")}
            </p>
            <a
              href={`mailto:info@paticastravel.com?subject=${encodeURIComponent(i18n.t("generalEmail.subject"))}&body=${encodeURIComponent(i18n.t("generalEmail.body"))}`}
              className="mt-1 italic text-sm text-white">info@paticastravel.com
            </a>
            <br />
            <a
              href={`https://api.whatsapp.com/send?phone=+50687758884&text=${i18n.t("whatsappMessage")}`}

              className="text-white mt-5 italic text-sm"
            >
              {i18n.t("footer.contact.phone")}
            </a>
            <div className="flex gap-4 mt-3 ">
              <div onClick={() => window.open('https://www.instagram.com/paticas_paque_las_quierocr/')} className="w-8 h-8 rounded-full bg-[#F0B500] flex items-center justify-content-center cursor-pointer">
                <FaInstagram className="text-xl text- text-black" />
              </div>
              <div onClick={() => window.open('https://www.facebook.com/Paticaspaquelasquiero')} className="w-8 h-8 rounded-full bg-[#F0B500] flex items-center justify-content-center cursor-pointer">
                <FaFacebookF className="text-xl text- text-black" />
              </div>
              <div onClick={() => window.open('https://www.tiktok.com/@paticastravelcr?_t=ZM-8zBhcPJlWKL&_r=1')} className="w-8 h-8 rounded-full bg-[#F0B500] flex items-center justify-content-center cursor-pointer">
                <FaTiktok className="text-xl text- text-black" />
              </div>
              <div onClick={() => window.open('https://www.tripadvisor.com/Attraction_Review-g309293-d33097180-Reviews-Paticas_Travel-San_Jose_San_Jose_Metro_Province_of_San_Jose.html')} className="w-8 h-8 rounded-full bg-[#F0B500] flex items-center justify-content-center cursor-pointer">
                <FaTripadvisor className="text-xl text- text-black" />
              </div>
            </div>
          </section >
        </div>
        <article className="bg-[#2a4328] w-full py-2 px-6 grid grid-cols-2 md:grid-cols-4 gap-6 items-center">
          <img src={Pyme} alt="PYME" className="w-24 mx-auto" />
          <img src={TripAdvisorIMG} alt="TripAdvisorIMG" className="w-24 mx-auto" />
          <img src={ICTLogo} alt="ICTLogo" className="w-44 col-span-1 justify-self-center" />
          <img src={ESSENTIALLogo} alt="ESSENTIALLogo" className="w-44 col-span-1 justify-self-center" />
        </article>
      </section>

      {/* Certifications */}
      {/* <section className="text-black py-8 px-6">
          <div className="max-w-7xl mx-auto grid md:grid-cols-4 gap-6 text-center md:text-left">
            <article className="p-4 bg-white shadow rounded-lg">{i18n.t("footer.certifications.tripadvisor")}</article>
            <article className="p-4 bg-white shadow rounded-lg">{i18n.t("footer.certifications.ict")}</article>
            <article className="p-4 bg-white shadow rounded-lg">{i18n.t("footer.certifications.nta")}</article>
            <article className="p-4 bg-white shadow rounded-lg">{i18n.t("footer.certifications.essential")}</article>
          </div>
        </section> */}

      {/* Newsletter */}
      <section className="max-w-7xl mx-auto grid md:grid-cols-4 gap-4 items-center text-center md:text-left" >
        <article className="p-4 text-black text-left md:col-span-2">
          {i18n.t("footer.newsletter.text")}
        </article>
        <article className="md:col-span-1">
          <input
            type="email"
            placeholder={i18n.t("footer.newsletter.placeholder")}
            className="mt-2 p-2 border border-gray-300 rounded w-11/12"
          />
        </article>
        <article className="md:col-span-1 flex justify-center md:justify-start">
          <button
            onClick={() => setOpenModal(true)}
            className="my-2 bg-[#2A4328] text-white px-4 py-2 rounded flex items-center"
          >
            {i18n.t("footer.newsletter.subscribe")} <IoIosArrowRoundForward className="ml-2 text-xl" />
          </button>
        </article>
      </section >

      {/* Bottom Section */}
      <section className="bg-[#65a603] py-6 px-6" >
        <article className="max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-between text-sm text-gray-300">
          <p>{i18n.t("footer.bottom.rights")}</p>
          <p className="mt-2 md:mt-0">{i18n.t("footer.bottom.motto")}</p>
        </article>
      </section >
    </footer >
  );
};

export default Footer;
